<template>
    <div class="bg-neutral-white">
      <CCol sm="12" xs="6" class="text-center">
        <h5 class="custom-18px poppin-font mt-0 text-center" style="padding-top: 40px;">
          <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
            <span style="margin-top:20px">Referral Program</span>
        </h5>
      </CCol>
      <div style="clear:both"></div>
      <br /><br />
      <CCol sm="12">
        <div class="m-0 justify-content-center align-items-center">
            <CTabs>
              <CTab title="Invite A Friend" active>
                <h5 class="custom-font-setting text-center mt-4">
                  <strong>Share your invite Code</strong>
                </h5>
                <br />
                <div class="bg-purple-card" style="padding: 15px; height: 55px; align-items: center;">
                  <div class="text-center">
                    <label class="custom-font-setting2"> 56Mnlp </label>
                    <img style="max-width: 25px;" src="../assets/img/copy.png" />
                  </div>
                </div>
                <br />
                <div class="text-center m-0">
                  <label class="custom-12px text-center">
                    *Get 10 Token when your friend sign up with Genie Workers using your referral code
                  </label>
                  
                  <CButton type="button" class="button-border-blue text-white mt-4" block>Invite A Friend</CButton>
                  <CButton type="button" class="button-border-blue-white" block>Showing QR Code</CButton>
                </div>

                <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

                <CButton type="button" class="button-border-blue text-white mt-4 mb-5" block>Continue</CButton>

              </CTab>
              <CTab title="Friend's Invitation">
                <h5 class="custom-font-setting mt-4 ml-3">
                  <strong>Enter Referral Code</strong>
                </h5>
                <CInput type="text" class="m-3" placeholder="Enter Card Number" />
                <br />
                <label class="custom-12px custom-font-setting2 ml-3" 
                  >Get extra credit when you use your friends referral
                  code.</label
                >
                <CButton type="button" class="button-border-blue text-white mt-4" block>Enter Code</CButton>
              </CTab>
            </CTabs>

          <br />

          

          <br />

          <br /><br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

          

          

          
          <br /><br />

        </div>
      
        
      </CCol>
    </div>
  </template>
  
  
  <script>
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  import {
      Hooper,
      Slide,
      Navigation as HooperNavigation,
      Pagination as HooperPagination,
  } from "hooper";
  
  import "hooper/dist/hooper.css";
  export default ({
      components: {
          Hooper,
          Slide,
          HooperNavigation,
          HooperPagination,
          MainlayoutBottom,
      },
      data() {
          return {
              isLanguagePopupVisible: false,
              code: ["", "", "", ""],
              hooperSettings1: {
                  hideArrows: true,
              },
              amountCustom: false,

  
          }
  
      },
      methods: {
          GoToPrevious() {
              this.$router.go(-1);
          },
  
        //   GoToLogin() {
        //       // Close the popup and backdrop
        //       this.$router.push("/RegisterHomepage");
        //   },
  
        //   GoToChangePassword() {
        //       // Close the popup and backdrop
        //       this.$router.push("/ChangePassword");
        //   },
        //   submitVerification() {
        //       const verificationCode = this.code.join(""); // Concatenate the digits
        //       console.log("Verification Code:", verificationCode);
  
        //       this.popupSuccess = true;
  
        //       // Add your logic to handle the verification code
        //   },
  
        // GoToWhatsapp() {
        //   this.$router.push("/EditProfile");
        // },

        customAmount() {
          this.amountCustom = true;
        },

        // closePopup() {
        //   this.$router.push("/EditSocmed");
        // }
  
      }
  })
  </script>
  
  <style scoped>
  body {
      top: 0 !important;
      font-family: 'Poppins', sans-serif;
  }
  </style>